/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetSubscriptionList Input Action
 */
export class GetSubscriptionListInput implements Msdyn365.IActionInput {
    constructor() {}

    public getCacheKey = () => `GetSubscriptionListInputCacheKey`;
    public getCacheObjectType = () => 'GetSubscriptionListInputObjectType';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IGetSubscriptionListData {
    SubBillBillingScheduleNumber: string;
    SubBillLineNum: number;
    SubBillScheduleStatus: number;
    SubBillItemName: string;
    SubBillStartDate: string;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetSubscriptionListInput();
};

async function action(input: GetSubscriptionListInput, ctx: Msdyn365.IActionContext): Promise<IGetSubscriptionListData[]> {
    let subscriptionList: IGetSubscriptionListData[] = [];
    await Msdyn365.sendRequest(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/TecGetAllActiveSubscriptions()?$top=100`,
        'get',
        {},
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${ctx.requestContext.user.token}`
            }
        }
    )
        .then(res => {
            subscriptionList = (res?.data as any).value;
        })
        .catch(ex => {
            console.log('Error', ex);
        });

    return subscriptionList;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetSubscriptionListData[]>>action,
    id: 'GetSubscriptionList',
    input: createInput
});
